import React from 'react';
import { motion } from 'framer-motion';
const details = [{
  title: 'EL INTERIOR.',
  description: 'Forro de seda satinada en color Magenta. Lujo que solo tú sabes que llevas, pero que todos notan en tu postura.'
}, {
  title: 'EL BORDADO.',
  description: 'Bordado 3D de alta densidad "Misery". Un relieve que impone respeto desde cualquier ángulo.'
}, {
  title: 'EL HERRAJE.',
  description: 'Corona "Royal" metálica en la parte trasera. El sello de autenticidad de un verdadero líder.'
}, {
  title: 'EL SELLO.',
  description: 'Lateral "Bien Jalapeño". Porque el estilo se demuestra en los detalles más picantes.'
}];
export function ProductDetails() {
  return <section className="bg-[#0A0A0A] py-20 px-4" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-bebas text-5xl md:text-6xl text-white text-center mb-16 tracking-wider" data-id="element-64">
          EL DETALLE DEL PATRÓN
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-65">
          {details.map((detail, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-black border border-gray-800 p-8 hover:border-misery-purple transition-all duration-300" data-id="element-66">
              <h3 className="font-bebas text-3xl md:text-4xl text-misery-magenta mb-4 tracking-wider" data-id="element-67">
                {detail.title}
              </h3>
              <p className="font-inter text-gray-300 leading-relaxed" data-id="element-68">
                {detail.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}